import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  private _params$ = new BehaviorSubject<{ [key: string]: string } | null>(
    null
  );

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  subscribeRouteParams() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child: ActivatedRoute | null = this.activatedRoute.firstChild;
          let params: { [key: string]: string } = {};

          while (child) {
            params = {
              ...params,
              ...child.snapshot.params
            };
            if (child.firstChild) {
              child = child.firstChild;
            } else {
              child = null;
            }
          }

          return params;
        })
      )
      .subscribe(value => this._params$.next(value));
  }

  get url() {
    return this.router.url;
  }

  getParam(key: string): string | undefined {
    return this.requireParams()[key];
  }

  get params() {
    return this._params$.value;
  }

  private requireParams(): { [key: string]: string } {
    const params = this._params$.value;
    if (!params) {
      throw new Error('Route parameters are read before the first navigation.');
    }
    return params;
  }

  get params$() {
    return this._params$.asObservable();
  }
}
